import { forbiddenState } from "./base.routes";

export function previousIfForbidden(rejectedPermission, transitionProperties) {
    return {
        state: forbiddenState,
        params: {
            redirect: {
                state: transitionProperties.fromState.name,
                params: transitionProperties.fromParams,
            },
        },
    };
}
